export default __webpack_public_path__ + "static/media/emojiParty.ac503d4d.png";